export const maybePlaceholderImage = (imageUrl?: string): string => {
  const ext = imageUrl?.split('.')?.pop()?.split('?')[0]?.toLowerCase()
  switch (ext) {
    case 'pdf':
      return 'assets/images/pdf.png'
    case 'jpg':
    case 'jpeg':
    case 'png':
    case 'webp':
    case 'gif':
    case 'svg':
      return imageUrl
    case 'doc':
    case 'docx':
      return 'assets/images/doc.png'
    case 'xls':
      return 'assets/images/xls.png'
    case 'xlsx':
      return 'assets/images/xlsx.png'
    default:
      return 'assets/images/awaiting-photo.svg'
  }
}
